module.exports = __webpack_public_path__ + "static/media/3DPPA29.2f7dcbd6.jpg";